import styled from 'styled-components';

export const MenuWrapper = styled.div`
  height: 100%;
  float: left;
`;
